<button type="button" class="btn btn-success btn-animated"><span>Success</span></button>
<button type="button" class="btn btn-danger btn-animated"><span>Danger</span></button>
<button type="button" class="btn btn-warning btn-animated"><span>Warning</span></button>
<button type="button" class="btn btn-info btn-animated"><span>Info</span></button>
